import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { Toggle } from '../Toggle/Toggle';

type Props = {
  disabled: boolean;
  isBookmarked: boolean;
  onBookmark: (isBookmarked: boolean) => void;
};

export const BookmarkButton = ({ disabled, isBookmarked, onBookmark }: Props) => {
  const [isSuccessfullyBookmarked, setIsSuccessfullyBookmarked] = useState(false);
  const [isHovered, setIsHovered] = useState(false);

  const { t } = useTranslation(['common']);

  return (
    <Toggle
      aria-label={t('common:actions.bookmark')}
      disabled={disabled || isSuccessfullyBookmarked}
      icon={isHovered ? 'BookmarkAdd' : 'Bookmark'}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      onPressedChange={(pressed) => {
        onBookmark(pressed);

        if (pressed) {
          setIsSuccessfullyBookmarked(true);
          setTimeout(() => setIsSuccessfullyBookmarked(false), 1000);
        }
      }}
      pressed={isBookmarked}
      pressedIcon={isSuccessfullyBookmarked ? 'BookmarkAdded' : isHovered ? 'BookmarkRemove' : 'BookmarkFilled'}
    />
  );
};
